<template>
  <footer class="bg-gray-200 flex justify-center" :class="{ 'border-t border-black': withBorder }">
    <section
      class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-x-4 md:gap-x-6 px-4 lg:px-6"
    >
      <section
        class="flex justify-between items-center col-span-full md:col-start-2 md:col-end-8 lg:col-end-12 py-7"
      >
        <section class="flex flex-col items-center lg:items-start">
          <section class="flex items-center gap-x-4 lg:mb-5">
            <span class="w-12 h-12 bg-gray-400 rounded-lg" />
            <p class="text-3xl" v-text="'Main logo'" />
          </section>
          <section v-if="isMobile" class="flex items-center gap-x-10 mt-10">
            <span class="w-9 h-9 bg-gray-400 rounded-full" />
            <span class="w-9 h-9 bg-gray-400 rounded-full" />
            <span class="w-9 h-9 bg-gray-400 rounded-full" />
          </section>
          <p
            class="text-lg font-bold pt-8 lg:pt-0 text-center lg:text-left"
            v-text="'AMOBASOFTWARE Copyright © 2020 All Rights Reserved'"
          />
        </section>
        <section v-if="!isMobile" class="flex items-center gap-x-10">
          <span class="w-9 h-9 bg-gray-400 rounded-full" />
          <span class="w-9 h-9 bg-gray-400 rounded-full" />
          <span class="w-9 h-9 bg-gray-400 rounded-full" />
        </section>
      </section>
    </section>
  </footer>
</template>
<script>
import utilsMixin from "../mixins/utilsMixin"
export default {
  mixins: [utilsMixin],
  props:{
    withBorder:{
      default: true
    }
  }
}
</script>
